import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'progress-notes',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './progress-notes.component.html',
  styleUrl: './progress-notes.component.css'
})
export class ProgressNotesComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() rmsRecordReviewData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  @ViewChild('datepickerReviewDate') datepickerReviewDate!: ElementRef;

  yesNo = EYesNo;
  reviewerInfoForm: FormGroup = new FormGroup([]);
  
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsRecordReviewData'] && this.rmsRecordReviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    group['review_date'] = new FormControl(this.rmsRecordReviewData?.review_date || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required);
    group['progress_notes'] = new FormControl(this.rmsRecordReviewData?.progress_notes || '', Validators.required);
  
    this.reviewerInfoForm = new FormGroup(group);
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerReviewDate) {
        new Datepicker(this.datepickerReviewDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.rmsRecordReviewData?.review_date) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerReviewDate.nativeElement.value = DateUtils.formatDateForDisplay(this.rmsRecordReviewData.review_date);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerReviewDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerReviewDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.reviewerInfoForm.get('review_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveReviewerInfo(): void {
    if (this.reviewerInfoForm.valid) {
      const data = this.reviewerInfoForm.value;
      this.onSaveSection2.emit(data);
    }
  }

}
